import React, { Component, Fragment } from "react"
import Async from "react-select"
import modalIcon from "../../../assets/images/testIcon.svg"
import cloth from "../../../assets/images/testIcon.svg"
import Field from "../../Common/Field/Field"
import ModuleHeader from "../ModuleHeader"
import FileUpload from "../../FileUpload/FileUpload"
import Button from "../../Buttons/Button"
import ButtonIcon from "../../Costing/Button/ButtonIcon"

export default class WashModule extends Component {
  state = {
    _id: "",
    wash: [],
    assignedToList: [],
    STATUS: [],
    disabled: false
  }

  componentWillMount() {
    const {
      _id,
      wash,
      washProcess,
      assignedToList,
      STATUS,
      WASHTYPE,
      WASHFORM,
      NOOFMOCKS,
      LU,
      PRICEPERKG,
      disabled
    } = this.props

    this.setState({
      _id,
      wash,
      washProcess,
      assignedToList,
      STATUS,
      disabled,
      WASHTYPE,
      WASHFORM,
      LU,
      PRICEPERKG,
      NOOFMOCKS
    })
  }

  componentWillReceiveProps(nextProps) {
    const {
      _id,
      wash,
      washProcess,
      assignedToList,
      STATUS,
      WASHTYPE,
      WASHFORM,
      NOOFMOCKS,
      LU,
      PRICEPERKG,
      disabled
    } = nextProps

    this.setState({
      _id,
      wash,
      washProcess,
      assignedToList,
      STATUS,
      disabled,
      WASHTYPE,
      WASHFORM,
      LU,
      PRICEPERKG,
      NOOFMOCKS
    })
  }

  render() {
    const { wash, disabled, STATUS, assignedToList } = this.state
    const { permissions } = this.props
    return (
      <div
        class="card-filter meeting-min-con"
        id="wash"
        style={{ marginBottom: ".5%" }}
      >
        <div class="col-md-12">
          <ModuleHeader
            header={"Wash"}
            onClick={this.onOpenModal}
            _id={this.state._id}
            process={this.state.washProcess}
            updateModulesMain={this.props.updateModulesMain}
            disabled={this.state.disabled}
            moduleName={"wash"}
            updateModulesMain={this.props.updateModulesMain}
            statusList={STATUS}
          />
          <div class="col-md-12 product-form" style={{ paddingBottom: "1%" }}>
            <div class="wash-container">
              <div class="col-md-12 no-padding">
                <div class="col-md-12 no-padding">
                  <div class="col-md-11 no-padding">
                    <div class="col-md-2 step-one pl-0">
                      <label>Wash Type</label>
                    </div>
                    <div class="col-md-2 step-one pl-0">
                      <label>{"Wash Form"}</label>
                    </div>
                    <div class="col-md-2 step-one pl-0">
                      <label>{"laundry Unit"}</label>
                    </div>
                    <div class="col-md-2 step-one pl-0">
                      <label>{"Price"}</label>
                    </div>
                    {/* <div className="col-md-1">
                      {permissions.create &&
                        permissions.edit &&
                        !this.state.disabled && (
                          <ButtonIcon
                            buttonType="add"
                            addRemoveFunc={() =>
                              this.props.changeWashData("add")
                            }
                          />
                        )}
                    </div> */}
                  </div>
                  {wash && wash.washData &&
                    <div class="col-md-11 no-padding">
                      <div class="col-md-2 step-one pl-0">
                        <Field
                          isFormGroup={false}
                          inputType="select"
                          inputName="washType"
                          value={wash.washData.washType}
                          options={this.state.WASHTYPE}
                          // index={index}
                          label={"Wash Type"}
                          onChange={this.props.updateWash1}
                          disabled={this.state.disabled}
                        />
                      </div>
                      <div class="col-md-2 step-one pl-0">
                        <Field
                          isFormGroup={false}
                          inputType="select"
                          inputName="washFrom"
                          value={wash.washData.washFrom}
                          options={this.state.WASHFORM}
                          // index={index}
                          label={"Wash Form"}
                          onChange={this.props.updateWash1}
                          disabled={this.state.disabled}
                        />
                      </div>
                      <div class="col-md-2 step-one pl-0">
                        <Field
                          isFormGroup={false}
                          inputType="select"
                          inputName="laundryUnit"
                          value={wash.washData.laundryUnit}
                          options={this.state.LU}
                          // index={index}
                          label={"laundry Unit"}
                          onChange={this.props.updateWash1}
                          disabled={this.state.disabled}
                        />
                      </div>
                      <div class="col-md-2 step-one pl-0">
                        <Field
                          isFormGroup={false}
                          inputType="number"
                          inputName="price"
                          value={wash.washData.price}
                          // index={index}
                          label={"Price/Kg"}
                          // options={this.state.PRICEPERKG&&this.state.PRICEPERKG.map(x=>({label:x.label,value:x.label}))}
                          onChange={this.props.updateWash1}
                          disabled={this.state.disabled}
                        />
                      </div>
                      {/* <div className="col-md-1">
                          {permissions.create &&
                            permissions.edit &&
                            !this.state.disabled && (
                              <ButtonIcon
                                buttonType="clear"
                                addRemoveFunc={() =>
                                  this.props.changeWashData("clear", index)
                                }
                              />
                            )}
                        </div> */}
                    </div>
                  }
                </div>
                <div class="col-md-12 no-padding">
                  <div class="col-md-2 step-one pl-0">
                    <Field
                      isFormGroup={true}
                      inputType="checkboxToggle"
                      inputName="hasMock"
                      value={wash.hasMock}
                      label="MOCKS ?"
                      onChange={this.props.updateWash}
                      disabled={this.state.disabled}
                    />
                  </div>
                  <div class="col-md-2 step-one pl-0">
                    <Field
                      isFormGroup={true}
                      inputType="select"
                      inputName="numberOfMocks"
                      value={wash.numberOfMocks}
                      options={this.state.NOOFMOCKS}
                      label={"No. Of Mocks"}
                      onChange={this.props.updateWash}
                      disabled={this.state.disabled}
                    />
                  </div>

                  <div class="col-md-2 step-one pl-0">
                    <Field
                      isFormGroup={true}
                      inputType="checkboxToggle"
                      inputName="tacking"
                      value={wash.tacking}
                      label="Tacking"
                      onChange={this.props.updateWash}
                      disabled={this.state.disabled}
                    />
                  </div>
                  <div class="col-md-2 step-one pl-0">
                    <Field
                      isFormGroup={true}
                      inputType="checkboxToggle"
                      inputName="recipe"
                      value={wash.recipe}
                      label="Recipe"
                      onChange={this.props.updateWash}
                      disabled={this.state.disabled}
                    />
                  </div>
                  <div class="col-md-12 nopadding">
                    <div class="col-md-12 no-padding" />
                    {/* {wash.recipe && ( */}
                    <div class="col-md-12 hide-customer-site">
                      <FileUpload
                        Heading="Upload Images"
                        moduleName={"marker"}
                        getRefImages={refImages =>
                          this.props.getRefImages(refImages, "wash")
                        }
                        disabled={this.state.disabled}
                        uploadedDocs={wash.refImages ? wash.refImages : null}
                        imageTypeOption={[]}
                      />
                    </div>
                    {/* )} */}
                    <div class="col-md-12 step-one">
                      <Field
                        isFormGroup={true}
                        inputType="textarea"
                        inputName="comments"
                        value={wash.comments}
                        label="comments"
                        onChange={this.props.updateWash}
                        disabled={this.state.disabled}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {!this.state.disabled && (permissions.create || permissions.edit) && (
              <div class="col-md-12 no-padding text-center profile-btn">
                <Button
                  buttonName={"save"}
                  onClick={e => this.props.createWash(e)}
                />
                <Button
                  buttonName={"Complete"}
                  onClick={e => this.props.completeWash(e)}
                />
              </div>
            )}
          </div>
          {/* )} */}
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/SampleRequest/WashModule/index.js